/* eslint-disable react/prop-types */
import SvgIcon from "@mui/material/SvgIcon";
import { useEffect, useState } from "react";

export default function AiLogoButton(props) {
  //const colors = { primary: "#FF5F00", secondary: "#3054A1" };
  const [color, setColor] = useState(props.color);
  useEffect(() => {
    setColor(props.color);
  }, [props.color]);

  return (
    <SvgIcon {...props} fontSize={props.size}>
      <svg
        version="1.1"
        id="Calque_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1080 1080"
        enableBackground="new 0 0 1080 1080"
        xmlSpace="preserve"
      >
        <g>
          <g>
            <defs>
              <path
                id="SVGID_1_"
                d="M216.1,0C96.7,0,0,96.7,0,216.1V864c0,119.3,96.7,216,216.1,216H864c119.3,0,216.1-96.7,216.1-216.1V216.1
				C1080,96.7,983.3,0,863.9,0H216.1z"
              />
            </defs>
            <clipPath id="SVGID_00000067204364942048109010000002499007862853676425_">
              <use xlinkHref="#SVGID_1_" overflow="visible" />
            </clipPath>

            <linearGradient
              id="SVGID_00000080182090880298159660000002267597189223117454_"
              gradientUnits="userSpaceOnUse"
              x1="-417.1264"
              y1="-5.1956"
              x2="-413.3528"
              y2="-5.1956"
              gradientTransform="matrix(146.6208 143.5817 -143.5817 146.6208 60832.332 61074.9336)"
            >
              <stop offset="0" stopColor={color} />
              <stop
                offset="1"
                stopColor={color == "#3054A1" ? "#1c2c57" : "#FF0050"}
              />
            </linearGradient>

            <polygon
              clipPath="url(#SVGID_00000067204364942048109010000002499007862853676425_)"
              fill="url(#SVGID_00000080182090880298159660000002267597189223117454_)"
              points="
			528.7,-539.9 1619.9,528.7 551.3,1619.9 -539.9,551.3 		"
            />
          </g>
        </g>
        <g>
          <g>
            <defs>
              <rect
                id="SVGID_00000011711553898137700230000017413766336951344825_"
                width="1080"
                height="1080"
              />
            </defs>
            <clipPath id="SVGID_00000039828611869359120880000005174452456421846201_">
              <use
                xlinkHref="#SVGID_00000011711553898137700230000017413766336951344825_"
                overflow="visible"
              />
            </clipPath>
            <path
              clipPath="url(#SVGID_00000039828611869359120880000005174452456421846201_)"
              fill="#FFFFFF"
              d="M801.7,439.5
			c-378.8,39.4-340,5.5-378.8,378.8C383.4,439.1,417,478.3,44,439.5c378.8-39.4,340-5.5,378.8-378.8
			C462.2,439.5,428.3,400.7,801.7,439.5"
            />
          </g>
          <g>
            <defs>
              <rect
                id="SVGID_00000105410691809957546140000003329800724945619366_"
                width="1080"
                height="1080"
              />
            </defs>
            <clipPath id="SVGID_00000096775805599059381130000017051408889150089651_">
              <use
                xlinkHref="#SVGID_00000105410691809957546140000003329800724945619366_"
                overflow="visible"
              />
            </clipPath>
            <path
              clipPath="url(#SVGID_00000096775805599059381130000017051408889150089651_)"
              fill="#FFFFFF"
              d="M937.6,511.6
			c-142.3,175.3-140.2,144.8,0,317.5c-175.4-142.4-145-140.1-317.6,0c142.3-175.3,140.2-144.8,0-317.5
			C795.3,653.8,764.9,651.7,937.6,511.6"
            />
          </g>
          <g>
            <defs>
              <rect
                id="SVGID_00000155118719775156936230000016474629651556115624_"
                width="1080"
                height="1080"
              />
            </defs>
            <clipPath id="SVGID_00000145767763307205354830000012672584333484471231_">
              <use
                xlinkHref="#SVGID_00000155118719775156936230000016474629651556115624_"
                overflow="visible"
              />
            </clipPath>
            <path
              clipPath="url(#SVGID_00000145767763307205354830000012672584333484471231_)"
              fill="#FFFFFF"
              d="M639.7,932.5
			c-122.8,12.8-110.3,1.8-122.8,122.8c-12.8-123-1.9-110.3-122.8-122.8c122.8-12.8,110.3-1.8,122.8-122.8
			C529.7,932.5,518.7,919.9,639.7,932.5"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
